export const getIdNumber = (id: string, item: string = "Product") => {
  return id.split(`/${item}/`)[1];
};
